export default {
  'nav.home': 'Startseite',
  'nav.shoppingGuide': 'Einkaufsführer',
  'nav.categories': 'Kategorien',
  'nav.faq': 'FAQ',
  'nav.mainSite': 'Hauptseite besuchen',
  'nav.language': 'Sprache',

  'hero.eyebrow': 'Unabhängige Ressource · Aktualisiert 2026',
  'hero.title': 'Basetao Spreadsheet Guide',
  'hero.subtitle':
    'Finden, vergleichen und organisieren Sie Produkte mit praktischen Basetao Spreadsheet-Ressourcen, Produktrecherche-Leitfäden, Funden, Versandinformationen und Bewertungen — alles an einem unabhängigen Ort.',
  'hero.ctaPrimary': 'basetao spreadsheet',
  'hero.ctaSecondary': 'jetzt kaufen',
  'hero.ctaGuide': 'Vollständigen Leitfaden erkunden',

  'categories.title': 'Nach Kategorie stöbern',
  'categories.subtitle':
    'Wählen Sie unten eine Kategorie, um direkt zu den kuratierten Produktlisten auf der Hauptseite zu springen.',
  'categories.dropdownLabel': 'Kategorie auswählen',

  'guide.title': 'Was ist ein Basetao Spreadsheet?',
  'guide.lead':
    'Ein Basetao Spreadsheet ist eine einfache Möglichkeit, die von Ihnen gefundenen Produkte zu organisieren, Preise und Verkäufer zu vergleichen und alle Links sowie Versanddetails an einem übersichtlichen Ort zu speichern.',

  'article.title': 'Basetao-Leitfäden erkunden',
  'article.subtitle': 'Zehn ausführliche Pillar-Guides, die Ihnen helfen, smarter zu recherchieren, zu versenden und zu sparen.',
  'article.readMore': 'Artikel lesen',

  'faq.title': 'Häufig gestellte Fragen',
  'faq.subtitle': 'Schnelle Antworten zu Basetao Spreadsheet und dieser Website.',

  'cta.title': 'Bereit, weiter zu recherchieren?',
  'cta.subtitle':
    'Setzen Sie Ihre Produktrecherche mit unseren Leitfäden fort, oder besuchen Sie die Hauptseite, um mit Ihren Funden zu beginnen.',
  'cta.mainSite': 'Hauptseite besuchen',
  'cta.guide': 'Recherche fortsetzen',

  'footer.tagline':
    'Eine unabhängige Informationsressource über Basetao Spreadsheet. Nicht mit Basetao verbunden oder von Basetao unterstützt.',
  'footer.resources': 'Ressourcen',
  'footer.company': 'Unternehmen',
  'footer.languages': 'Sprachen',
  'footer.disclaimer':
    'Basetao Sheet Guide ist eine unabhängige Informationswebsite und nicht mit Basetao verbunden oder von Basetao unterstützt, sofern nicht ausdrücklich angegeben.',

  'hero.demoLabel': 'Demo-Daten nur zur Veranschaulichung.',
  'guide.readFullGuide': 'Vollständigen Leitfaden lesen',
  'guide.exampleLabel': 'Beispiel-Tabellenstruktur (Demo-Daten)',

  'article.faqTitle': 'Häufig gestellte Fragen',
  'article.relatedTitle': 'Verwandte Leitfäden',
  'article.ctaTitle': 'Recherche fortsetzen',
  'article.ctaText':
    'Bereit, Produkte zu Ihrem Sheet hinzuzufügen? Erkunden Sie die Kategorien oder kehren Sie zur Startseite zurück für weitere Ressourcen.',
  'article.backToHome': 'Zurück zur Startseite',
  'article.visitMainSite': 'Hauptseite besuchen',
  'article.author': 'Basetao Sheet Guide Team',

  'notFound.title': 'Artikel nicht gefunden',
  'notFound.text':
    'Die gesuchte Seite existiert nicht. Kehren Sie zur Startseite zurück, um unsere Leitfäden zu erkunden.',
  'notFound.backToHome': 'Zurück zur Startseite',

  'home.metaDescription':
    'Erkunden Sie Basetao Spreadsheet-Leitfäden, Funde, Bewertungen, Versandkosten, Lagerinformationen, QC-Tipps, Coupons und praktische Ressourcen.',
};